import "../../node_modules/@popperjs/core/dist/cjs/popper";
import * as bootstrap from 'bootstrap';
import 'vanilla-cookieconsent';
// TODO: refactoring before or shortly after page is live

// Initialization of popovers
[...document.querySelectorAll('[data-bs-toggle="popover"]')].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl));

if (document.getElementById('copyUuid') != null) {
	document.getElementById('copyUuid').onclick = (e) => {
		navigator.clipboard.writeText(document.getElementById('uuidOutput').innerHTML);
		setTimeout(() => bootstrap.Popover.getOrCreateInstance('#copyUuid').hide(), 2000);
	}
}

// Cookie consent setup
const cookieConstent = initCookieConsent(document.getElementsByTagName('body')[0]);
cookieConstent.run({
    auto_language: "browser",
    autoclear_cookies: true,                   // default: false
    page_scripts: true,  
    cookie_expiration: 182,
    languages: {
        'en': {
            consent_modal: {
                title: 'We use cookies! 🍪',
                description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
                primary_btn: {
                    text: 'Accept all',
                    role: 'accept_all'              // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: 'Reject all',
                    role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                }
            },
            settings_modal: {
                title: 'Cookie preferences',
                save_settings_btn: 'Save settings',
                accept_all_btn: 'Accept all',
                reject_all_btn: 'Reject all',
                close_btn_label: 'Close',
                cookie_table_headers: [
                    {col1: 'Name'},
                    {col2: 'Domain'},
                    {col3: 'Expiration'},
                    {col4: 'Description'}
                ],
                blocks: [
                    {
                        title: 'Cookie usage 🍪',
                        description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/en/data-protection" class="cc-link">data protection page</a>.'
                    }, {
                        title: 'Strictly necessary cookies',
                        description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                        }
                    }, {
                        title: 'Advertisement and Targeting cookies',
                        description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                        toggle: {
                            value: 'targeting',
                            enabled: false,
                            readonly: false
                        }
                    }, {
                        title: 'More information',
                        description: 'For any informations in relation to our policy on cookies and your choices, please refer to the <a class="cc-link" href="/en/data-protection">data protection page</a>.',
                    }
                ]
            }
        },
        'de': {
            consent_modal: {
                title: 'Wir verwenden Cookies! 🍪',
                description: 'Hi, diese Website verwendet essentielle Cookies, um ihren ordnungsgemäßen Betrieb zu gewährleisten und Tracking-Cookies, um unser Angebot verbessern zu können. Letztere werden nur nach Zustimmung gesetzt. <button type="button" data-cc="c-settings" class="cc-link">Cookie Einstellungen</button>',
                primary_btn: {
                    text: 'Alle annehmen',
                    role: 'accept_all'              // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: 'Alle ablehnen',
                    role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                }
            },
            settings_modal: {
                title: 'Cookie Präferenzen',
                save_settings_btn: 'Einstellungen speichern',
                accept_all_btn: 'Alle annehmen',
                reject_all_btn: 'Alle ablehnen',
                close_btn_label: 'Schließen',
                cookie_table_headers: [
                    {col1: 'Name'},
                    {col2: 'Domain'},
                    {col3: 'Läuft ab'},
                    {col4: 'Beschreibung'}
                ],
                blocks: [
                    {
                        title: 'Verwendung von Cookies 🍪',
                        description: 'Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und um Ihr Online-Erlebnis zu verbessern. Sie können für jede Kategorie wählen, ob Sie sich ein- oder austragen möchten. Für weitere Einzelheiten zu Cookies und anderen sensiblen Daten lesen Sie bitte die vollständige <a href="/de/data-protection" class="cc-link">Datenschutzerklärung</a>.'
                    }, {
                        title: 'Notwendige Cookies',
                        description: 'Diese Cookies sind für das ordnungsgemäße Funktionieren unserer Website unerlässlich. Ohne diese Cookies würde die Website nicht richtig funktionieren.',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true
                        }
                    }, {
                        title: 'Analyse- und Werbe-Cookies',
                        description: 'Diese Cookies sammeln Informationen darüber, wie Sie die Website nutzen, welche Seiten Sie besucht und welche Links Sie angeklickt haben. Alle Daten sind anonymisiert und können nicht verwendet werden, um Sie zu identifizieren.',
                        toggle: {
                            value: 'targeting',
                            enabled: false,
                            readonly: false
                        }
                    }, {
                        title: 'Weitere Informationen',
                        description: 'Informationen zu unseren Richtlinien in Bezug auf Cookies und Ihre Wahlmöglichkeiten finden Sie in der <a class="cc-link" href="/de/data-protection">Datenschutzerklärung</a>.',
                    }
                ]
            }
        }
    }
});